import { Navigate } from "react-router-dom";
import { ROLE } from "../constants/roles";
import { decryptRole } from "../App";

type guardProps = {
  children: JSX.Element;
  allowedRoles: string[];
};

export const AuthGaurd = ({ children, allowedRoles }: guardProps) => {
  let userData = JSON.parse(
    localStorage.getItem("userData") ||
      sessionStorage.getItem("userData") ||
      "null"
  );
  let userRole = decryptRole(userData?.role);
  const allRoles = Object.values(ROLE);
  if (allowedRoles.indexOf(userRole) !== -1) return <>{children}</>;
  if (allRoles.indexOf(userRole) === -1) {
    return <Navigate to="/restric-user" />;
  }
  return (
    <>
      {" "}
      {userRole === "Commercial" || userRole === "Corporate" ? (
        <Navigate to="/c-dashboard" />
      ) : (
        <Navigate to="/" />
      )}
      {userRole === "Admin" && <Navigate to="/system-admin-dashboard" />}
      {userRole === "ThirdParty" && <Navigate to="/third-party-dashboard" />}
      {userRole === "Lawyers" && <Navigate to="/lawyers-dashboard" />}
    </>
  );
};
